import React from "react";
import { Card } from "antd";

/**
 * Kaart met een kop van drie delen: titel links, teller/context ernaast,
 * acties rechts. Elk blok op een detailpagina ("Producten", "Betalingen",
 * "Geschiedenis") is zo'n kaart, zodat de pagina uit leesbare secties bestaat
 * in plaats van één lange lap.
 */
const SectionCard = ({ title, meta, extra, children, footer, padded = false, bodyStyle }) => (
  // overflow: hidden zoals in het ontwerp — antd's Card heeft het niet, waardoor
  // te brede inhoud (een tabel zonder scroll.x) tot buiten de kaart doorliep en
  // onder de zijkolom verdween. Vangnet naast scroll.x, geen vervanging ervan.
  <Card style={{ overflow: "hidden" }} styles={{ body: { padding: 0, minWidth: 0, ...bodyStyle } }}>
    {title || extra ? (
      <div
        style={{
          padding: "14px 20px",
          borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", gap: 10, minWidth: 0 }}>
          <span style={{ fontSize: 15, fontWeight: 500 }}>{title}</span>
          {meta ? <span style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)" }}>{meta}</span> : null}
        </div>
        {extra ? <div style={{ display: "flex", gap: 8, alignItems: "center" }}>{extra}</div> : null}
      </div>
    ) : null}
    <div style={padded ? { padding: "16px 20px" } : undefined}>{children}</div>
    {footer ? (
      <div
        style={{
          padding: "12px 20px",
          borderTop: "1px solid rgba(5, 5, 5, 0.06)",
          display: "flex",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        {footer}
      </div>
    ) : null}
  </Card>
);

export default SectionCard;
